import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useToast } from "../components/CustomToast";
import AuthImage from "../images/auth-image.png";
import { Button } from "../partials/actions/Button";
import logo from "../images/landingPage/logo.svg";

function Signin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { addToast } = useToast();
  const auth = getAuth();

  const handleSignin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
      addToast("Du er nu logget ind!", "success");
    } catch (error) {
      let errorMessage;
      console.log(error.code, "code");
      switch (error.code) {
        case "auth/invalid-email":
          errorMessage = "Invalid email format.";
          break;
        case "auth/user-not-found":
          errorMessage = "No user found with this email.";
          break;
        case "auth/wrong-password":
          errorMessage = "Incorrect password.";
          break;
        case "auth/invalid-credential":
          errorMessage = "Din email eller kodeord er forkert.";
          break;
        default:
          errorMessage = "Der opstod en fejl, prøv igen senere!";
      }
      addToast(errorMessage, "error");
    }
  };

  return (
    <main className="bg-black dark:bg-gray-900">
      <div className="relative md:flex">
        {/* Content */}
        <div className="md:w-1/2">
          <div className="min-h-[100dvh] h-full flex flex-col after:flex-1">
            {/* Header */}
            <div className="flex-1">
              <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
                {/* Logo */}
                <Link className="block" to="/">
                  <img src={logo} alt="Logo" className="h-20 w-auto" />
                </Link>
              </div>
            </div>

            <div className="max-w-sm mx-auto w-full px-4 py-8">
              <h1 className="text-3xl text-white font-bold mb-6">
                Velkommen tilbage!
              </h1>
              {/* Form */}
              <form onSubmit={handleSignin}>
                <div className="space-y-4">
                  <div>
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor="email"
                    >
                      Email
                    </label>
                    <input
                      id="email"
                      className="form-input w-full"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div>
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor="password"
                    >
                      Kodeord
                    </label>
                    <input
                      id="password"
                      className="form-input w-full"
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="text-center mt-2">
  <Link
    to="/terms-and-policy"
    className="text-sm text-violet-500 font-medium hover:underline"
  >
    Vilkår og betingelser
  </Link>
</div>
                  <div>
                    <Button
                      type="submit"
                      text="Log ind"
                      variant="primary"
                      className={"w-full rounded-md mt-4"}
                    />
                  </div>
                  
                </div>
              </form>
              {/* Additional Links */}
              <div className="text-center mt-4">
                <Link
                  to="/reset-password"
                  className="text-sm text-violet-500 hover:underline"
                >
                  Glemt kodeord?
                </Link>
              </div>
              <div className="text-center mt-2">
  <span className="text-sm text-gray-600 dark:text-gray-400">
    Har du ikke en profil?{" "}
  </span>
  <Link
    to="/signup"
    className="text-sm text-violet-500 font-medium hover:underline"
  >
    Opret profil
  </Link>
</div>
            </div>
          </div>
        </div>
        {/* Image and Quote */}
        <div className="hidden md:flex md:w-1/2 bg-gray-100 h-screen overflow-auto flex-col justify-between">
          <div className="p-8 text-right text-black">
            <p className="text-lg font- ">
              "Someone's sitting in the shade today,<br /> because someone
              planted a tree a long time ago."
            </p>
            <p className="text-sm mt-2">- Warren Buffett</p>
          </div>
          <div className="relative flex justify-end items-end h-full">
            <img
              className="object-contain w-2/3 h-auto"
              src={AuthImage}
              alt="Authentication"
            />
          </div>
        </div>
      </div>
    </main>
  );
}

export default Signin;